module.exports = __webpack_public_path__ + "img/my-doubts.33fe4d32.svg";